import { render, staticRenderFns } from "./UploadDocumentsDialog.vue?vue&type=template&id=d8cc71aa"
import script from "./UploadDocumentsDialog.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentsDialog.vue?vue&type=script&lang=ts"
import style0 from "./UploadDocumentsDialog.vue?vue&type=style&index=0&id=d8cc71aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports